<div class="risk">
  <span class="fs-16 fw-600 semi-bold">{{ title }}</span>
  <div slider id="slider-distance" style="width: 100%; margin-top: 3rem">
    <div>
      <div inverse-left style="width: 100%"></div>
      <div inverse-right style="width: 100%"></div>
      <div
        range
        [ngStyle]="{
          left: minValue + '%',
          right: 100 - maxValue + '%',
        }"
      ></div>
      <span thumb [ngStyle]="{ left: minValue + '%' }"></span>
      <span thumb [ngStyle]="{ left: maxValue + '%' }"></span>
      <div sign [ngStyle]="{ left: minValue - 5.5 + '%' }">
        <span id="value">{{ minValue }} %</span>
      </div>
      <div sign [ngStyle]="{ left: maxValue - 5.5 + '%' }">
        <span id="value">{{ maxValue }} %</span>
      </div>
    </div>
    <input
      type="range"
      tabindex="0"
      value="{{ minValue }}"
      max="100"
      min="0"
      step="1"
    />

    <input
      type="range"
      tabindex="0"
      value="{{ maxValue }}"
      max="100"
      min="0"
      step="1"
    />
  </div>
</div>
